export default __webpack_public_path__ + "static/media/chushka.37936c44.png";